import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  public year: number;
  constructor() {
    let date: Date = new Date();
    this.year = date.getFullYear();
  }

  ngOnInit(): void {}
}
